import { DataActiveStatusEnum } from "../../Category/types";
import { IData, ProductState } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  price: "",
  taxRate: "",
  images: [],
  status: DataActiveStatusEnum.ACTIVE,
  subCategoryId: "",
  shipmentCapacity: "",
  allergicImages: [],
  stickers: [],
  shortDescription: "",
  longDescription: "",
  code: "",
  size: "",
  featuredImage: [],
  subCategoryTitle:""
};

export const initialState: ProductState = {
  formData: {
    ...defaultFormData,
  },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  allGroupList: []
};
